import { useState } from "react";
import { toast } from "sonner";
import { useLanguage } from "../context/LanguageContext";
import { subscribeNewsletter } from "../lib/api";

export const Newsletter = () => {
  const { t, lang } = useLanguage();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || loading) return;
    setLoading(true);
    try {
      await subscribeNewsletter(email, lang);
      toast.success(t.newsletter.success);
      setEmail("");
    } catch (err) {
      toast.error(t.newsletter.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section
      data-testid="newsletter-section"
      className="relative bg-yellow-400 text-black py-20 md:py-28 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-5 mix-blend-overlay noise" />
      <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center relative">
        <p className="text-[11px] font-black tracking-[0.35em] uppercase text-black/70">
          {t.newsletter.overline}
        </p>
        <h2 className="h-display text-black text-6xl sm:text-7xl md:text-8xl mt-4">
          {t.newsletter.title}
        </h2>
        <p className="max-w-xl mx-auto mt-4 text-black/70 text-lg">
          {t.newsletter.subtitle}
        </p>

        <form
          onSubmit={onSubmit}
          data-testid="newsletter-form"
          className="mt-10 max-w-xl mx-auto flex flex-col sm:flex-row gap-0"
        >
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t.newsletter.placeholder}
            data-testid="newsletter-email-input"
            className="flex-1 bg-black/5 border border-black text-black placeholder-black/50 px-5 py-4 text-sm focus:outline-none focus:bg-black/10"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="newsletter-submit"
            className="btn-cabo btn-cabo--dark disabled:opacity-50"
          >
            {loading ? t.newsletter.subscribing : t.newsletter.cta}
          </button>
        </form>
      </div>
    </section>
  );
};
